import selectDatadict from './src/';

export default selectDatadict;


// WEBPACK FOOTER //
// ./src/components/select-datadict/index.js